export const services = [
  {
    id: 'design-consultation',
    icon: 'fa-comments',
    translationKey: 'designConsultation',
  },
  {
    id: 'property-evaluation',
    icon: 'fa-clipboard-check',
    translationKey: 'propertyEvaluation',
  },
  {
    id: 'kitchen-design',
    icon: 'fa-kitchen-set',
    translationKey: 'kitchenDesign',
  },
  {
    id: 'bathroom-design',
    icon: 'fa-bath',
    translationKey: 'bathroomDesign',
  },
  {
    id: 'home-staging',
    icon: 'fa-couch',
    translationKey: 'homeStaging',
  },
];

export const packages = [
  {
    id: 'package-1',
    icon: 'fa-lightbulb',
    translationKey: 'package1',
  },
  {
    id: 'package-2',
    icon: 'fa-pencil-ruler',
    translationKey: 'package2',
  },
  {
    id: 'package-3',
    icon: 'fa-hard-hat',
    translationKey: 'package3',
  },
];
